export default __webpack_public_path__ + "static/media/ag-white.ededef00.svg";